import { createApp, h } from 'vue'
import Login from './AppToast.vue'

interface ToastOptions {
  type: 'success' | 'error' | 'warning' | 'text'
  message: string
  backgroundColor?: string
  duration?: number
  onClose?: () => void
  // 定位相关选项
  targetElement?: string // 目标元素选择器
  offset?: { x: number; y: number } // 偏移量
}

export type ToastServiceType = (options: ToastOptions) => void

let appInstance: any = null
let app: ReturnType<typeof createApp> | null = null
const destroyApp = () => {
  // 从 DOM 中移除实例
  app?.unmount()
  appInstance = null

  // 移除临时的 div
  const div = document.querySelector('#app-toast')
  if (div) {
    document.body.removeChild(div)
  }
}
const ToastService = (options: ToastOptions) => {
  if (!appInstance) {
    app = createApp({
      render() {
        return h(Login, {
          ...options,
          onClose: () => {
            options.onClose && options.onClose()
            destroyApp()
          }
        })
      }
    })

    const div = document.createElement('div')
    div.id = 'app-toast'
    document.body.appendChild(div)
    appInstance = app.mount(div)
  }
}

export default ToastService
